"use strict";

export class Shape {
    static centerPoint(vertices) {
        return Matter.Vertices.centre(vertices);
    }

    static offsetVertices(vertices,offset) {
        for (let i = 0; i < vertices.length; i++) {
            vertices[i].x -= offset.x;
            vertices[i].y -= offset.y;
        }
    }
}